/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        var searchKeyName = ApiKeyNames.search;

        return function() {
            return {
                structuredGeocode: requestFactory.single(endpoints.structuredGeocode, searchKeyName),
                batch: requestFactory.batch(100, {
                    single: endpoints.batchStructuredGeocodeQuery,
                    batch: endpoints.batchSearch,
                    batchSync: endpoints.batchSyncSearch
                }, searchKeyName)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/structuredGeocode.js